const e = "_table_i13be_1", t = "_fixed_i13be_6", _ = "_thead_i13be_9", i = "_tbody_i13be_9", o = "_tfoot_i13be_9", c = "_tr_i13be_9", s = "_th_i13be_9", b = "_td_i13be_9", n = "_sorter_i13be_48", d = "_expander_i13be_49", a = "_icon_i13be_61", r = "_left_i13be_66", l = "_right_i13be_69", f = "_blue_i13be_89", p = "_compact_i13be_112", h = "_isMobileDivide_i13be_119", x = "_isSpaceBetween_i13be_159", u = {
  table: e,
  fixed: t,
  thead: _,
  tbody: i,
  tfoot: o,
  tr: c,
  th: s,
  td: b,
  sorter: n,
  expander: d,
  icon: a,
  left: r,
  right: l,
  blue: f,
  compact: p,
  isMobileDivide: h,
  isSpaceBetween: x
};
export {
  f as blue,
  p as compact,
  u as default,
  d as expander,
  t as fixed,
  a as icon,
  h as isMobileDivide,
  x as isSpaceBetween,
  r as left,
  l as right,
  n as sorter,
  e as table,
  i as tbody,
  b as td,
  o as tfoot,
  s as th,
  _ as thead,
  c as tr
};
//# sourceMappingURL=table.module.less.js.map
